export const SPONSOR_NUMBER_TYPES = {
  LIMITED: 'LIMITED',
  UNLIMITED: 'UNLIMITED'
}

export const SPONSOR_AMOUNT_TYPES = {
  FIXED: 'Fixed amount',
  OPEN: 'Open amount',
  RANGE: 'Ranged amount'
}
